<template>
  <div>
    <a-card>
      <h3 class='mb20'>版本管理</h3>
      <a-card :loading="loading" title="线上版本" class="mb20">
        <p class="s_text_c" >你暂无线上版本</p>
        <div class="mod_default_bd default_box online_version" >
          <div class="code_version_log_hd">
            <div class="simple_preview_item"><label for="" class="simple_preview_label">版本号</label>
              <p class="simple_preview_value">{{releaseVersion.user_version}}</p>
            </div>
          </div>
          <div class="code_version_log_ft">
            <div class="user_status">
                <a-button type="primary" v-has:editionBack="back">
                  版本回退
                </a-button>
            </div>
          </div>
          <div class="code_version_log_bd">
            <!-- <div class="simple_preview_item"><label for="" class="simple_preview_label">发布者</label>
              <p class="simple_preview_value">{{releaseVersion.}}</p>
            </div> -->
            <div class="simple_preview_item"><label for="" class="simple_preview_label">发布时间</label>
              <p class="simple_preview_value">{{releaseVersion.create_time}}</p>
            </div>
            <div class="simple_preview_item"><label for="" class="simple_preview_label">项目备注</label>
              <p class="simple_preview_value">{{releaseVersion.user_desc}}</p>
            </div>
          </div>
        </div>
      </a-card>
      <a-card :loading="loading" title="审核版本">
      <p class="s_text_c" v-if="!auditVersion.id"> 你暂无提交审核的版本或者版本已发布上线</p>
         <div class="mod_default_bd default_box online_version" v-else>
          <div class="code_version_log_hd">
            <div class="simple_preview_item"><label for="" class="simple_preview_label">版本号</label>
              <p class="simple_preview_value">{{auditVersion.user_version}}</p>
              <span class="status_tag" style="cursor: pointer; color: rgb(255, 145, 41); border: 1px solid rgb(255, 145, 41);" v-if="auditVersion.audit_status==0">
                审核成功
              </span>
               <span class="status_tag" style="cursor: pointer; color: rgb(255, 145, 41); border: 1px solid rgb(255, 145, 41);" v-if="auditVersion.audit_status==1">
                审核拒绝
              </span>
               <span class="status_tag" style="cursor: pointer; color: rgb(255, 145, 41); border: 1px solid rgb(255, 145, 41);" v-if="auditVersion.audit_status==2">
                审核中
              </span>
               <span class="status_tag" style="cursor: pointer; color: rgb(255, 145, 41); border: 1px solid rgb(255, 145, 41);" v-if="auditVersion.audit_status==3">
                已撤回
              </span>
               <span class="status_tag" style="cursor: pointer; color: rgb(255, 145, 41); border: 1px solid rgb(255, 145, 41);" v-if="auditVersion.audit_status==4">
                审核延后
              </span>
            </div>
          </div>
          <div class="code_version_log_ft">
            <div class="user_status" v-if="auditVersion.audit_status==0">
                <a-button type="primary" v-has:editionRelease="release">
                  发布
                </a-button>
            </div>
          </div>
          <div class="code_version_log_bd">
            <div class="simple_preview_item"><label for="" class="simple_preview_label">发布者</label>
              <p class="simple_preview_value">{{auditVersion.user_desc}}</p>
            </div>
            <div class="simple_preview_item"><label for="" class="simple_preview_label">发布时间</label>
              <p class="simple_preview_value">{{auditVersion.update_time}}</p>
            </div>
            <div class="simple_preview_item"><label for="" class="simple_preview_label">项目备注</label>
              <p class="simple_preview_value">{{auditVersion.user_desc}}</p>
            </div>
            <!---->
          </div>
        </div>
      </a-card>
    </a-card>
  </div>
</template>
<script>
import { getAppletEdition,miniappRevert } from "@/api/appletCode";
import { inject, onMounted, reactive, toRefs } from 'vue'
import { $iscode } from '../../../../utils/app';
export default {
  setup(){
    const $Modal=inject('$Modal')
    const state=reactive({
      detail:{},
      releaseVersion:{},
      auditVersion:{}
    })
    const $route=inject('$route')
    const  initData=async ()=>{
      let result=await getAppletEdition({brand_id:$route.query.brand_id,app_id:$route.query.app_id}).then(res=>res.data).catch(error=>error)
      state.auditVersion=result.data.auditVersion
      state.releaseVersion=result.data.releaseVersion
    }
    onMounted(()=>{
      initData()
    })
    const back=()=>{
        $Modal.confirm({
          content: '确定要回退上一个版本么？', onOk:async () => {
            let result=await miniappRevert({release_id:state.releaseVersion.id}).then(res=>res.data).catch(error=>error)
            $iscode(result,true)
             initData()
          }
        })
    }
    // 确定要发布么
     const release=()=>{
        $Modal.confirm({
          content: '确定要发布该版本么？', onOk:async () => {
           
          }
        })
    }
    return {
      ...toRefs(state),
      back,
      release
    }
  }
}
</script>
<style lang="less">
.code_version_log_hd {
  float: left;
  width: 120px;
  color: #333;
  .code_version_log .simple_preview_item:first-child {
    padding-top: 0;
  }
  .code_version_log .simple_preview_label {
    width: 60px;
  }
  .simple_preview_value {
    font-size: 22px;
    display: block;
    padding-top: 2px;
  }
}
.simple_preview_label{
    float: left;
    width: 5em;
    margin-right: 1em;
}
.code_version_log_ft {
  float: right;
  margin-left: 30px;
}
.code_version_log_bd {
  overflow: hidden;
}
.user_status{
  padding-top: 20px;
}
.status{
    font-size: 12px;
    padding: 2px;
    margin-left: 10px;
    border-radius: 2px;
    display: inline-block;
    line-height: 1;
    vertical-align: middle;
    margin-top: -0.2em;
}

</style>